import { gql } from 'graphql-request'

class CustomerMutations {
  createCustomer = gql`
    mutation CreateCustomer($data: CustomerCreateInput!) {
      createCustomer(data: $data) {
        id
        name
        nbClaimedPlaces
        nbRemainingLicenses
        nbExperiences
        createdAt
      }
    }
  `

  updateCustomer = gql`
    mutation UpdateCustomer($where: CustomerWhereUniqueInput!, $data: CustomerUpdateInput!) {
      updateCustomer(where: $where, data: $data) {
        id
        name
        nbClaimedPlaces
        nbRemainingLicenses
        nbExperiences
        createdAt
      }
    }
  `

  deleteCustomer = gql`
    mutation DeleteCustomers($where: CustomersWhereIdsInput!) {
      deleteCustomers(where: $where) {
        count
      }
    }
  `
}

const customerMutations = new CustomerMutations()

export default customerMutations
